const LoadMoreButton = () => {
  return (
    <button class="rounded-lg bg-gradient-to-r from-[#B14DFF] to-[#4A72FF] px-14 py-4 font-clash font-bold font-semibold">
      Load More
    </button>
  )
}

export default LoadMoreButton
